import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {UrlBuilder} from "../url-builder/url.builder";
import {MeasurementDescriptionList} from "./MeasurementDescriptionList";


@Injectable({
  providedIn: 'root'
})
export class MeasurementDescriptionDataservice {

  private uiUrl: string = "";
  private url: UrlBuilder;

  constructor(private http: HttpClient) {
    this.url = new UrlBuilder();
  }

  GetData(): Observable<MeasurementDescriptionList> {
    this.uiUrl = this.url.GetMeasurementDescriptionUrl();
    console.log('FILE: ' + this.uiUrl);
    return this.http.get<MeasurementDescriptionList>(this.uiUrl);
  }



}

